import { useContext } from "react";
import { MobileShellContext } from "./mobile-shell-context.js";

export function useMobileShell() {
  return useContext(MobileShellContext);
}
